module.exports = __webpack_public_path__ + "img/tris.5f53e98.svg";